import { render, staticRenderFns } from "./GlobalTip.vue?vue&type=template&id=15131147&"
import script from "./GlobalTip.vue?vue&type=script&lang=js&"
export * from "./GlobalTip.vue?vue&type=script&lang=js&"
import style0 from "./GlobalTip.vue?vue&type=style&index=0&id=15131147&prod&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports